class TrackingStatusInfoMapper {
  static createModelFromResponse(data) {
    if (!data) {
      return undefined;
    }
    return {
      description: data.description,
      category: data.category,
      isIncident: data.is_incident
    };
  }
}

export { TrackingStatusInfoMapper };
//# sourceMappingURL=TrackingStatusInfoMapper.js.map
